<template>
  <div class="div404">
    <a-row>
      <a-col :span="8"> </a-col>
      <a-col :span="4">
        <img src="../../assets/404.png" />
      </a-col>
      <a-col :span="4">
        <div class="content-404">
          <h1>404</h1>
          <h2>UH OH! 页面丢失</h2>
          <p>您所寻找的页面不存在。你可以点击下面的按钮，返回主页。</p>
          <a-button @click="linkToDashboard">返回首页</a-button>
        </div>
      </a-col>
      <a-col :span="8"> </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  methods: {
    linkToDashboard() {
      this.$router.push({ path: '/Dashboard' }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.div404 {
  height: 300px;
  position: relative;
  top: 50%;
  margin-top: -200px;
}
.content-404 {
  position: relative;
  top: -20px;
  left: 40px;
}
.content-404 h1 {
  font-size: 9.5em;
  font-weight: bold;
  margin: -20px 0 0 -20px;
}
</style>
